module.exports = __webpack_public_path__ + "img/4e07dab.jpg";